import { useQuery } from '@tanstack/react-query';

import { logisticsApi } from 'api/logistics';

export const crossDockPurchaseOrderQueryKeys = {
    all: ['crossDockPurchaseOrders'],
    search: (params) => [...crossDockPurchaseOrderQueryKeys.all, 'search', params],
};

/**
 * @param {{ limit: number, offset: number }} params
 * @param {import('@tanstack/react-query').UseQueryOptions} [options]
 */
export const useCrossDockPurchaseOrdersSearch = (params, options = {}) =>
    useQuery({
        queryKey: crossDockPurchaseOrderQueryKeys.search(params),
        queryFn: async ({ signal }) => {
            const response = await logisticsApi.listCrossDockPurchaseOrders(params, { signal });
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Failed to fetch cross dock purchase orders');
            }
            return {
                rows: response.data?.rows ?? [],
                pagination: response.data?.pagination ?? {},
            };
        },
        staleTime: 30 * 1000,
        ...options,
    });
